module.exports = __webpack_public_path__ + "assets/images/05_da25d753b9e9104f208f20523e5958e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/gameplay/05.png
// module id = 208
// module chunks = 0